import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApplicationService } from '@enauka/shared/application';
import { AuthService } from '@enauka/shared/infrastructure/auth/data-access';
import { mergeMap } from 'rxjs/operators';
import { ZeszytOnlineService } from '../zeszyt-online.service';

@Component({
  selector: 'enauka-cas',
  templateUrl: './cas.component.html',
  styleUrls: ['./cas.component.css']
})
export class CasComponent implements OnInit {

  constructor(private zeszytOnlinService: ZeszytOnlineService,
    private route: ActivatedRoute,
    private applicationService: ApplicationService,
    private authService: AuthService) { }

  ngOnInit(): void {
    const ticket = this.route.snapshot.queryParamMap.get('ticket');
    if (ticket) {
      this.zeszytOnlinService.verifyCasToken(ticket)
        .pipe(
          mergeMap(() => this.authService.updateUserPrincipal())
        )
        .subscribe(() => {
          location.href = '/uczen/';//pominiecie mechanizmow angulara
        }, (err) => {
          console.error(err);
          this.applicationService.goHome();
        });
    } else {
      this.applicationService.goHome();
    }
  }
}
